/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import AuthorSetContent from '../components/Author-Set-Content';
import Banner from '../components/Banner';
import BlogCard from '../components/Blog-Card';
import BlogContent from '../components/Blog-Content';
import Bodytext from '../components/Bodytext';
import BottomCTA from '../components/Bottom-CTA';
import Button from '../components/Button';
import CalendlyWidget from '../components/CalendlyWidget';
import CareersList from '../components/CareersList';
import CarrierBandSlides from '../components/Carrier-Band-Slides';
import Checkbox from '../components/Checkbox';
import CheckboxGroup from '../components/CheckboxGroup';
import CMSButton from '../components/CMS-Button';
import CollapsiblePanel from '../components/CollapsiblePanel';
import ContactBar from '../components/Contact-Bar';
import ContentBlock from '../components/ContentBlock';
import CostModule from '../components/Cost-Module';
import CrossSellPolicies from '../components/Cross-Sell-Policies';
import CTABanner from '../components/CTA-Banner';
import CustomerTestimonial from '../components/Customer-Testimonial';
import CustomImage from '../components/CustomImage';
import ExploreCardSection from '../components/Explore-Card-Section';
import ExploreOnInsureon from '../components/Explore-On-Insureon';
import FeaturedContent from '../components/Featured-Content';
import FeaturedPosts from '../components/Featured-Posts';
import H2andIcon from '../components/H2andIcon';
import H3andIcon from '../components/H3andIcon';
import Heading from '../components/Heading';
import HomepageHero from '../components/Homepage-Hero';
import HomepageHeroColumns from '../components/Homepage-Hero-Columns';
import HorizontalScroller from '../components/HorizontalScroller';
import ImageWrapper from '../components/ImageWrapper';
import Incontent from '../components/In-content';
import IndustryRouting from '../components/Industry-Routing';
import LeadRoutingNumberAttribution from '../components/Lead-Routing-Number-Attribution';
import LegalDescriptor from '../components/LegalDescriptor';
import LinkWrapper from '../components/LinkWrapper';
import Media from '../components/Media';
import ModalCTA from '../components/Modal-CTA';
import MultiColumn from '../components/MultiColumn';
import PageDescription from '../components/Page-Description';
import Pagination from '../components/Pagination';
import PolicyCard from '../components/Policy-Card';
import PolicyCardList from '../components/Policy-Card-List';
import PolicyCardListQ221 from '../components/Policy-Card-List-Q221';
import PolicyCardQuote from '../components/Policy-Card-Quote';
import PolicyDescription from '../components/Policy-Description';
import PolicyRecommendationCTA from '../components/Policy-Recommendation-CTA';
import PolicyRecommendationQuestionnaire from '../components/PolicyRecommendationQuestionnaire';
import Popover from '../components/Popover';
import PostsByTag from '../components/Posts-By-Tag';
import Preview from '../components/Preview';
import PullQuote from '../components/Pull-Quote';
import Q221CustomerTestimonial from '../components/Q221-Customer-Testimonial';
import Q221SeriesValueProp from '../components/Q221-Series-Value-Prop';
import QuoteLanding from '../components/Quote-Landing';
import Radio from '../components/Radio';
import RadioGroup from '../components/RadioGroup';
import RecentPosts from '../components/RecentPosts';
import RelatedPolicies from '../components/RelatedPolicies';
import RelatedPosts from '../components/RelatedPosts';
import RelatedTopics from '../components/RelatedTopics';
import ResponsiveImage from '../components/Responsive-Image';
import ScrollToTop from '../components/ScrollToTop';
import SearchBot from '../components/SearchBot';
import Section from '../components/Section';
import SidebarSection from '../components/SidebarSection';
import SpecialList from '../components/Special-List';
import StateModule from '../components/State-Module';
import Stepper from '../components/Stepper';
import Table from '../components/Table';
import TagBand from '../components/TagBand';
import TestMetadata from '../components/Test-Metadata';
import TrustPilotWidget from '../components/TrustPilot-Widget';
import UniversalRouter from '../components/UniversalRouter';
import ValueProp from '../components/ValueProp';
import Video from '../components/Video';
import VideoComponent from '../components/VideoComponent';
import VideoComponentWithList from '../components/VideoComponentWithList';

const components = new Map();
components.set('Author-Set-Content', AuthorSetContent);
components.set('Banner', Banner);
components.set('Blog-Card', BlogCard);
components.set('Blog-Content', BlogContent);
components.set('Bodytext', Bodytext);
components.set('Bottom-CTA', BottomCTA);
components.set('Button', Button);
components.set('CalendlyWidget', CalendlyWidget);
components.set('CareersList', CareersList);
components.set('Carrier-Band-Slides', CarrierBandSlides);
components.set('Checkbox', Checkbox);
components.set('CheckboxGroup', CheckboxGroup);
components.set('CMS-Button', CMSButton);
components.set('CollapsiblePanel', CollapsiblePanel);
components.set('Contact-Bar', ContactBar);
components.set('ContentBlock', ContentBlock);
components.set('Cost-Module', CostModule);
components.set('Cross-Sell-Policies', CrossSellPolicies);
components.set('CTA-Banner', CTABanner);
components.set('Customer-Testimonial', CustomerTestimonial);
components.set('CustomImage', CustomImage);
components.set('Explore-Card-Section', ExploreCardSection);
components.set('Explore-On-Insureon', ExploreOnInsureon);
components.set('Featured-Content', FeaturedContent);
components.set('Featured-Posts', FeaturedPosts);
components.set('H2andIcon', H2andIcon);
components.set('H3andIcon', H3andIcon);
components.set('Heading', Heading);
components.set('Homepage-Hero', HomepageHero);
components.set('Homepage-Hero-Columns', HomepageHeroColumns);
components.set('HorizontalScroller', HorizontalScroller);
components.set('ImageWrapper', ImageWrapper);
components.set('In-content', Incontent);
components.set('Industry-Routing', IndustryRouting);
components.set('Lead-Routing-Number-Attribution', LeadRoutingNumberAttribution);
components.set('LegalDescriptor', LegalDescriptor);
components.set('LinkWrapper', LinkWrapper);
components.set('Media', Media);
components.set('Modal-CTA', ModalCTA);
components.set('MultiColumn', MultiColumn);
components.set('Page-Description', PageDescription);
components.set('Pagination', Pagination);
components.set('Policy-Card', PolicyCard);
components.set('Policy-Card-List', PolicyCardList);
components.set('Policy-Card-List-Q221', PolicyCardListQ221);
components.set('Policy-Card-Quote', PolicyCardQuote);
components.set('Policy-Description', PolicyDescription);
components.set('Policy-Recommendation-CTA', PolicyRecommendationCTA);
components.set('PolicyRecommendationQuestionnaire', PolicyRecommendationQuestionnaire);
components.set('Popover', Popover);
components.set('Posts-By-Tag', PostsByTag);
components.set('Preview', Preview);
components.set('Pull-Quote', PullQuote);
components.set('Q221-Customer-Testimonial', Q221CustomerTestimonial);
components.set('Q221-Series-Value-Prop', Q221SeriesValueProp);
components.set('Quote-Landing', QuoteLanding);
components.set('Radio', Radio);
components.set('RadioGroup', RadioGroup);
components.set('RecentPosts', RecentPosts);
components.set('RelatedPolicies', RelatedPolicies);
components.set('RelatedPosts', RelatedPosts);
components.set('RelatedTopics', RelatedTopics);
components.set('Responsive-Image', ResponsiveImage);
components.set('ScrollToTop', ScrollToTop);
components.set('SearchBot', SearchBot);
components.set('Section', Section);
components.set('SidebarSection', SidebarSection);
components.set('Special-List', SpecialList);
components.set('State-Module', StateModule);
components.set('Stepper', Stepper);
components.set('Table', Table);
components.set('TagBand', TagBand);
components.set('Test-Metadata', TestMetadata);
components.set('TrustPilot-Widget', TrustPilotWidget);
components.set('UniversalRouter', UniversalRouter);
components.set('ValueProp', ValueProp);
components.set('Video', Video);
components.set('VideoComponent', VideoComponent);
components.set('VideoComponentWithList', VideoComponentWithList);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
